import { createReducer } from '@reduxjs/toolkit';
import { Reducer } from 'redux';

import {
    CalendarEventsActions,
    CalendarEventsState,
    clearEvents,
    eventLoadingStatusSet,
    eventsLoad,
    eventsLoadSuccess,
    eventsSearchLoadSuccess,
    eventsSearchReset,
} from './calendar-events.actions';

const initialState: CalendarEventsState = {
    queryString: '',
    eventCardSearchedIds: [],
    eventCards: [],
    eventCardsDates: [],
    eventsLoading: true,
};

export const calendarEventsReducer: Reducer<CalendarEventsState, CalendarEventsActions> = createReducer(
    initialState,
    (builder) => {
        builder
            .addCase(eventsLoad, (state: CalendarEventsState) =>
                Object.assign<object, CalendarEventsState, Partial<CalendarEventsState>>({}, state, {
                    eventCards: [],
                }),
            )
            .addCase(eventsLoadSuccess, (state: CalendarEventsState, action: ReturnType<typeof eventsLoadSuccess>) =>
                Object.assign<object, CalendarEventsState, Partial<CalendarEventsState>>({}, state, {
                    eventCards: action.payload,
                }),
            )
            .addCase(
                eventLoadingStatusSet,
                (state: CalendarEventsState, action: ReturnType<typeof eventLoadingStatusSet>) =>
                    Object.assign<object, CalendarEventsState, Partial<CalendarEventsState>>({}, state, {
                        eventsLoading: action.payload,
                    }),
            )
            .addCase(
                eventsSearchLoadSuccess,
                (state: CalendarEventsState, action: ReturnType<typeof eventsSearchLoadSuccess>) =>
                    Object.assign<object, CalendarEventsState, Partial<CalendarEventsState>>({}, state, {
                        eventCardSearchedIds: action.payload,
                    }),
            )
            .addCase(eventsSearchReset, (state: CalendarEventsState) =>
                Object.assign<object, CalendarEventsState, Partial<CalendarEventsState>>({}, state, {
                    eventCardSearchedIds: [],
                }),
            )
            .addCase(clearEvents, (state: CalendarEventsState) =>
                Object.assign<object, CalendarEventsState, Partial<CalendarEventsState>>({}, state, {
                    eventCards: [],
                }),
            );
    },
);
